import React, { useEffect, useState } from "react";
import { Expand, Star, ArrowUpRight } from "lucide-react";
import { fetchPublic, resolveImg } from "../adminApi";
import { BOOKING_URL } from "../../mock/mock";
import { Reveal, SplitWords } from "../motionHelpers";
import Lightbox from "../Lightbox";

export default function Coaches() {
  const [coaches, setCoaches] = useState([]);
  const [lightbox, setLightbox] = useState(null);
  useEffect(() => {
    fetchPublic("coaches").then(setCoaches).catch(() => setCoaches([]));
  }, []);

  if (!coaches.length) return null;

  const images = coaches.map((c) => resolveImg(c.photo)).filter(Boolean);

  return (
    <section id="coaches" className="bg-sc-cream py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-5 lg:px-8">
        <div className="mb-14">
          <span className="font-grotesk uppercase tracking-[0.3em] text-sc-orange text-sm">Learn from the best</span>
          <h2 className="font-display uppercase text-sc-green text-5xl md:text-7xl leading-[0.9] mt-3">
            <SplitWords text="Meet the Coaches" />
          </h2>
          <p className="font-grotesk text-sc-green/60 mt-4 max-w-xl">Certified, equipped and empowering — our coaching team is here to level up your game.</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {coaches.map((c, i) => (
            <Reveal key={c.id || c.name} delay={i * 0.08}>
              <div className="group flex flex-col">
                <button
                  type="button"
                  data-hover
                  data-testid={`coach-card-${i}`}
                  onClick={() => c.photo && setLightbox(i)}
                  className="relative block w-full overflow-hidden rounded-2xl border border-sc-green/10 shadow-lg bg-sc-green/5 focus:outline-none focus:ring-2 focus:ring-sc-lime"
                >
                  {c.photo ? (
                    <img
                      src={resolveImg(c.photo)}
                      alt={c.name}
                      loading="lazy"
                      className="w-full h-auto object-cover transition-transform duration-700 group-hover:scale-[1.04]"
                    />
                  ) : (
                    <div className="aspect-[5/7] flex items-center justify-center font-display text-6xl text-sc-green/30">{(c.name || "?")[0]}</div>
                  )}
                  {i === 0 && (
                    <span className="absolute top-3 left-3 inline-flex items-center gap-1.5 bg-sc-lime text-[#06170f] font-grotesk uppercase tracking-widest text-[10px] font-bold px-3 py-1.5 rounded-full shadow">
                      <Star className="w-3 h-3 fill-[#06170f]" /> Founder
                    </span>
                  )}
                  {c.photo && (
                    <span className="absolute bottom-3 right-3 w-10 h-10 rounded-full bg-white/85 text-sc-green flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                      <Expand className="w-4 h-4" />
                    </span>
                  )}
                </button>
                <div className="mt-4">
                  <h3 className="font-display uppercase text-2xl text-sc-green leading-none">{c.name}</h3>
                  <p className="font-mono2 uppercase text-[11px] tracking-widest text-sc-orange mt-2">{c.role}</p>
                  <a
                    href={BOOKING_URL}
                    target="_blank"
                    rel="noreferrer"
                    data-hover
                    data-testid={`coach-book-${i}`}
                    className="mt-4 inline-flex items-center justify-center gap-2 w-full bg-sc-green text-sc-cream hover:bg-sc-lime hover:text-[#06170f] font-grotesk uppercase tracking-wide text-xs font-bold rounded-full px-5 py-3 transition-colors"
                  >
                    Book a Lesson <ArrowUpRight className="w-4 h-4" />
                  </a>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>

      <Lightbox images={images} index={lightbox} onClose={() => setLightbox(null)} onChange={setLightbox} alt="Supreme Courts Coach" />
    </section>
  );
}
